import { NgModule } from '@angular/core';
import { NvFormFieldModule as NvSharedFormFieldModule } from 'projects/shared/nvps-libraries/design/nv-form-field/nv-form-field.module';

@NgModule({
  imports: [NvSharedFormFieldModule],
  exports: [NvSharedFormFieldModule],
})
export class NvFormFieldModule {}
